import { Device } from "main/types/device";
export function getCurrentDevice() {
    if (window.innerWidth < 768)
        return Device.MOBILE;
    if (window.innerWidth < 991)
        return Device.TABLET;
    return Device.DESKTOP;
}
